﻿import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function DashboardLayout() {
  const { session } = useAuth();
  
  return (
    <div className="min-h-screen bg-background text-on-background relative overflow-x-hidden">
      <Header />
      <Sidebar />
      <main className={`ml-0 md:ml-20 pb-12 px-4 md:px-8 ${session?.user?.mustChangePassword ? 'pt-36' : 'pt-24'}`}>
        <div className="max-w-6xl mx-auto w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
